import React from 'react';
import { NotificationManager } from 'react-notifications';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { ServiceSupplier } from '../../services/service-supplier';
import { serviceAreas } from '../../services/service-areas';
import serviceCredibility from '../../services/service-credibility';
import services from '../../services';
import appState from '../../state/AppStateContainer';
import { validateEmail, validateOptionalPhone, formatAreaLabel } from '../../util';
import { checkOrgNo, isValidOrganizationNumber } from '../../utils/bt-number';
import './app-add-supplier.css';
import 'react-toggle/style.css';
import { CustomToggle } from '../../components/shared';
import Field from '../../components/shared/Field/Field';
import BtButton from '../bt-button/bt-button';
import Modal from '../../components/shared/Modal/Modal';
import Selector from '../../components/shared/Selector/Selector';
import DatePicker from '../../components/shared/DatePicker/DatePicker';
import SupplierMemberContainer from '../page-quotation/ContactInfoForm/SupplierMemberContainer/SupplierMemberContainer';
import SuggestedContactContainer from '../page-quotation/ContactInfoForm/SupplierMemberContainer/SuggestedContactContainer';
import moment from 'moment';
import { regions } from '../../staticData/regions';
import SupplierControls from './supplier-controls';
import { mergeCompanyLookUp, registerFields, withoutProfileFields } from './registerPick';
import SupplierIdentity from './SupplierIdentity';
import ImagePreview from '../../components/shared/ImagePreview/ImagePreview';
import { FileScope } from '../../util/appEnum';
import FileUpload from '../../components/shared/FileUpload/FileUpload';
import FileUploadRow from '../../components/shared/FileUploadRow/FileUploadRow';
import StyledCheckbox from '../../components/shared/StyledCheckbox/StyledCheckbox';
import RecommendedAd from './recommended-ad';
import LogoForm from './logoForm';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import { ReactComponent as VerifiedIcon } from '../../assets/svg/verifiedIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/svg/InfoIconLight.svg';
import FileCommentDate from './file-comment-date';
import serviceSales from '../../services/service-sales';
import { Trans, withTranslation } from 'react-i18next';
import { Form, getSubmittableForm, Mode, readFormFromDB } from '../../components/shared/Form/Form';
import { ShortText } from '../../components/shared/Form/ShortText/ShortText';
import { SingleSelection } from '../../components/shared/Form/SingleSelection/SingleSelection';
import { LongText } from '../../components/shared/Form/LongText/LongText';
import { Paragraph } from '../../components/shared/Form/Paragraph/Paragraph';
import { MultiSelection } from '../../components/shared/Form/MultiSelection/MultiSelection';
import { ServiceSupplierApplicationForm } from '../../services/service-supplier-application-form';
import PlaceSelector, { placeOptions } from '../page-supplier-presentation/PlaceSelector';
import SimpleFile from '../../components/SimpleFile/SimpleFile';
import ArrowIcon from '../../components/svgs/arrowIcon';
import { ReactComponent as FileIcon } from '../../assets/svg/file.svg';

const newContact = () => ({tempId: Date.now(), name: '', email: '', phone: '', title: '', editMode: true, errors: {}, isRemoved: false});

class AppAddEditSupplier extends React.Component {

  constructor(props) {
    super(props);
    const { t } = props;

    this.identityFieldOptions = [
      { label: t('addSupplier.identityFieldOptions.organizationNumber', 'Org.nr'), value: 'organizationNumber' },
      { label: t('addSupplier.identityFieldOptions.vatNumber', 'VAT-nummer'), value: 'vatNumber' },
    ];

    this.invoiceIntervalOptions = [
      { label: t('addSupplier.invoiceIntervalOptions.6months', '6 månader: 15 000 kr'), value: '6 månader: 15 000 kr' },
      { label: t('addSupplier.invoiceIntervalOptions.12months', '12 månader: 25 000 kr'), value: '12 månader: 25 000 kr' }
    ];

    const editSupplierData = props.editSupplierData;
    const supplierProfile = props.editSupplierData?.supplierProfile ?? this.emptySupplierProfile();

    this.state = {
      suggestions: [],
      data: {
        name: editSupplierData.name,
        city: editSupplierData.city,
        areaIds: editSupplierData.areaIds || [],
        organizationNumber: editSupplierData.organizationNumber,
        vatNumber: editSupplierData.vatNumber,
        selectedIdentityField: this.getSelectedIdentityField(editSupplierData),
        website: editSupplierData.website,
        description: editSupplierData.description,
        address: editSupplierData.address,
        postnumber: editSupplierData.postnumber,
        kommun: editSupplierData?.kommun?.value === 'Utomlands' ? { ...editSupplierData.kommun, label: 'Utomlands / Other' } : editSupplierData.kommun,
        places: editSupplierData.supplierProfile?.places?.length > 0 ? editSupplierData.supplierProfile?.places : editSupplierData.places ?? [],
        isBlacklist: editSupplierData.isBlacklist || false,
        blacklistReason: editSupplierData.blacklistReason ?? [],
        existingFrameworkAgreements: editSupplierData.frameworkAgreements || [],
        newFrameworkAgreements: [],
        existingLiabilityInsurances: editSupplierData.liabilityInsurances || [],
        newLiabilityInsurances: [],
        profileLiabilityInsurances: supplierProfile?.liabilityInsurances,
        existingUE2021Forms: editSupplierData.ue2021Forms || [],
        newUE2021Forms: [],
        existingOtherFiles: editSupplierData.otherFiles || [],
        newOtherFiles: [],
        logo: editSupplierData.supplierProfile?.logo ?? editSupplierData.logo,
        updateLogo: false,
        isFeatured: editSupplierData?.isFeatured,
        featuredInfo: editSupplierData?.featuredInfo,
        updateFeaturedInfoImage: false,
        message: '',
        invoiceInterval: this.invoiceIntervalOptions[0].value,
      },
      applicationForm: null,
      files: {},
      supplierId: editSupplierData.supplierId,
      slide: 1,
      suggestionType: 'city',
      suggestionLimit: 5,
      checkedAreaItems: [],
      dropDownCities: [],
      formErrors: {},
      focusedDatePicker: null, // { sectionKey: 'ue2021'|'liability'|'framework', index, isNew }
      defaultAreaIds: [],
      lookingUp: null,
      areas: [],
      places: placeOptions,
      contacts: editSupplierData.contacts?.length ? editSupplierData.contacts : [newContact()],
      ads: [],
      showQuickCheck: false,
      frameworkAgreementsExpanded: false,
      liabilityInsurancesExpanded: false,
      ue2021FormsExpanded: false,
      supplierProfile: editSupplierData?.supplierProfile,
    };
  }
  inputsWrapper;

  element;
  projectName;
  modalHide;
  btnSaveButton;
  innerInput;

  getSelectedIdentityField = (data) => {
    const { t } = this.props;
    const selectedOption = this.identityFieldOptions.find(option => option.value === data.selectedIdentityField);
    if (selectedOption) return selectedOption;

    if (`${data.organizationNumber}`.startsWith('0') && data.vatNumber) {
      return { label: t('addSupplier.identityFieldOptions.vatNumber', 'VAT-nummer'), value: 'vatNumber' };
    }

    return { label: t('addSupplier.identityFieldOptions.organizationNumber', 'Org.nr'), value: 'organizationNumber' };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.editSupplierData != nextProps.editSupplierData && nextProps.editSupplierData) {
      const data = {};
      const editSupplierData = nextProps.editSupplierData;

      data.name = editSupplierData.name;
      data.city = editSupplierData.city;
      data.areaIds = editSupplierData.areaIds;
      data.organizationNumber = editSupplierData.organizationNumber;
      data.vatNumber = editSupplierData.vatNumber;
      data.selectedIdentityField = this.getSelectedIdentityField(editSupplierData);
      data.website = editSupplierData.website;
      data.description = editSupplierData.description;
      data.address = editSupplierData.address;
      data.postnumber = editSupplierData.postnumber;
      data.kommun = editSupplierData.kommun;
      data.places = editSupplierData.supplierProfile?.places?.length > 0 ? editSupplierData.supplierProfile?.places : editSupplierData.places ?? [];
      data.isBlacklist = editSupplierData.isBlacklist || false;
      data.blacklistReason = editSupplierData.blacklistReason || [];
      data.existingFrameworkAgreements = editSupplierData.frameworkAgreements || [];
      data.newFrameworkAgreements = [];
      data.existingLiabilityInsurances = editSupplierData.liabilityInsurances || [];
      data.newLiabilityInsurances = [];
      data.existingUE2021Forms = editSupplierData.ue2021Forms || [];
      data.newUE2021Forms = [];
      data.existingOtherFiles = editSupplierData.otherFiles || [];
      data.newOtherFiles = [];
      data.logo = editSupplierData.supplierProfile?.logo ?? editSupplierData.logo;
      data.updateLogo = false;
      data.updateFeaturedInfoImage = false;
      data.isFeatured = editSupplierData.isFeatured;
      data.featuredInfo = editSupplierData.featuredInfo;

      if (!editSupplierData.supplierId && !editSupplierData.address) {
        data.address = '';
      }

      this.setState({
        data: data,
        supplierId: editSupplierData.supplierId,
        slide: 1,
      });

      this.fetchCities().then(() => this.fetchAreas().then(() => {
        this.addDefaultAreaIds();

        const ads = (editSupplierData?.ads || []).map(ad => ({
          ...ad,
          errors: {},
          areas: ad.areas.map(area => this.state.areas.find(_area => _area.id == area)),
          regions: ad.regions.map(region => regions.find(_region => region === _region.label))
        }));

        this.setState({ ads });

        if (editSupplierData?.supplierId) {
          ServiceSupplier.getSupplierMembers(editSupplierData.supplierId).then(contacts => {
            if (contacts?.length) this.setState({ contacts: contacts.map(contact => ({ ...contact, editMode: false })) });
          });
        }
      }));
    }
  }

  addDefaultAreaIds = (areas) => {
    const { editSupplierData } = this.props;
    let defaultIds = editSupplierData.areaIds;
    if (areas && defaultIds) {
      const filteredArray = defaultIds.map(sup => areas.find(s => s.id === sup));
      this.setState({ defaultAreaIds: filteredArray });
    }
  };

  componentDidMount() {
    (async() => {
      const { editSupplierData } = this.props;
      await this.fetchCities();
      const areas = await this.fetchAreas();
      this.addDefaultAreaIds(areas);

      if (editSupplierData && editSupplierData.supplierId) {
        const ads = (editSupplierData?.ads || []).map(ad => ({
          ...ad,
          errors: {},
          areas: ad.areas.map(area => areas.find(_area => _area.id == area)),
          regions: ad.regions.map(region => regions.find(_region => region === _region.label))
        }));

        this.setState({ ads });

        const contacts = await ServiceSupplier.getSupplierMembers(editSupplierData.supplierId);
        if (contacts?.length) this.setState({ contacts: contacts.map(contact => ({ ...contact, editMode: false })) });
      }

      if (this.props.supplierApplication) {
        const form = await ServiceSupplierApplicationForm.getSupplierApplicationFormForOrganization();
        this.setState({ applicationForm: readFormFromDB(form, Mode.FORM) });
      }
    })();
  }

  fetchCities = async () => {
    const citiesData = await services.getCities();
    let dropDownCities = [];
    citiesData.forEach(item => {
      const label = item === "Utomlands" ? "Utomlands / Other" : item;
      dropDownCities.push({ value: item, label: label });
    });
    this.setState({ dropDownCities });
  };

  fetchAreas = async () => {
    const areasData = await serviceAreas.getAreas();
    let areas = [];
    areasData.forEach(item => areas.push({ id: item._id, label: formatAreaLabel(item.name, item.accountNumber), value: item.name }));
    this.setState({ areas });
    return areas;
  };

  toggleBtnLoader = () => this.setState({ btnLoader: !this.state.btnLoader });

  onSaveSupplier = async () => {
    if (this.state.btnLoader) return;
    const { t } = this.props;

    const validateSupMembers = (members) => {
      let valid = true;
      const newMembers = members.map(member => ({...member, errors: {}}));
      for (const member of newMembers) {
        if (!member.isRemoved) {
          Object.entries(member).forEach(([key, value]) => {
            if ((key === 'name' || key === 'email') && value === '') {
              member.errors[key] = t('validation:required', 'Obligatoriskt');
              valid = false;
            } else if (key === 'email' && validateEmail(value)) {
              member.errors[key] = t('validation:email', 'Ogiltig e-postadress');
              valid = false;
            } else if (key === 'phone' && value && validateOptionalPhone(value)) {
              member.errors[key] = t('validation:phone', 'Ogiltigt telefonnummer');
              valid = false;
            }
          });
        }
      }

      this.setState({ contacts: newMembers });

      return valid;
    }

    const validateAds = (ads) => {
      let valid = true;

      const newAds = ads.map(ad => ({...ad, errors: {}}));
      for (const ad of newAds) {
        Object.entries(ad).forEach(([key, value]) => {
          if (['areas', 'regions'].includes(key) && !value?.length) {
            ad.errors[key] = t('validation:required', 'Obligatoriskt');
            valid = false;
          }
        })
      }

      this.setState({ ads: newAds });

      return valid;
    }

    const { data, supplierId, contacts, ads, agreedToContract } = this.state;
    let formErrors = {};
    let formData = Object.assign({},data);

    formData.ads = ads.map(({ _id, startDate, endDate, areas, regions }) => ({ _id, startDate, endDate, areas: areas.map(area => area.id), regions: regions.map(region => region.label)}));

    formData.contacts = contacts;
    formData.removedMembers = contacts.filter(contact => contact.isRemoved).map(contact => contact._id);
    formData.isNewContacts = supplierId && contacts.length > 0;
    formData.selectedIdentityField = formData.selectedIdentityField.value;

    const fieldNames = {
      name: t('addSupplier.fieldNames.name', 'Företagsnamn'),
      city: t('addSupplier.fieldNames.city', 'Län'),
      areaIds: t('addSupplier.fieldNames.areaIds', 'Professionella områden'),
      organizationNumber: t('addSupplier.fieldNames.organizationNumber', 'Organisationsnummer'),
      vatNumber: t('addSupplier.fieldNames.vatNumber', 'VAT - Nummer'),
      website: t('addSupplier.fieldNames.website', 'Webbplats'),
      description: t('addSupplier.fieldNames.description', 'Beskrivning'),
      address: t('addSupplier.fieldNames.address', 'Adress'),
      postnumber: t('addSupplier.fieldNames.postnumber', 'Postnummer'),
      kommun: t('addSupplier.fieldNames.kommun', 'Kommun'),
      places: t('supplierDetailPanel.profileInfo.places.title', 'Verksamhetsområden'),
      isBlacklist: 'isBlacklist',
      blacklistReason: 'blacklistReason',
      contacts: 'contacts',
      isNewContacts: 'isNewContacts',
      removedMembers: 'removedMembers',
    };

    Object.keys(formData).forEach((key) => {
      if ([
        'website',
        'postnumber',
        'city',
        'isBlacklist',
        'blacklistReason',
        'isNewContacts',
        'address',
        'description',
        'removedMembers',
        'existingFrameworkAgreements',
        'newFrameworkAgreements',
        'existingLiabilityInsurances',
        'newLiabilityInsurances',
        'profileLiabilityInsurances',
        'existingUE2021Forms',
        'newUE2021Forms',
        'ads',
        'isFeatured',
        'featuredInfo',
        'logo',
        'updateLogo',
        'updateFeaturedInfoImage',
        'newOtherFiles',
        'existingOtherFiles',
        'message',
        'invoiceAddress',
        'invoiceReference',
        'invoiceInterval',
        'places'
      ].includes(key) || this.identityFieldOptions.find(option => option.value === key && option.value !== formData.selectedIdentityField)) {
        return;
      }
      const val = formData[key];
      if (
        !val
        || (val instanceof Array && !val.length)
        || (key === 'organizationNumber' && formData.selectedIdentityField === key && val.length !== 11)
      ) {
        if (!fieldNames[key]) {
          console.log(`Form error for unknown field ${key}, make it optional or add it to the fieldNames object.`);
        }
        formErrors[key] = t('validation:required', 'Obligatoriskt');
      }
    });

    if (this.state.applicationForm) {
      const identityOptionSelected = this.identityFieldOptions.find(option => option.value === formData.selectedIdentityField);
      const convertedElements = [
        new ShortText({ question: identityOptionSelected.label, renderId: 'selectedIdentityField', answer: formData[identityOptionSelected.value], required: true }),
        new ShortText({ question: fieldNames.name, renderId: 'name', answer: formData.name, required: true }),
        new LongText({ question: fieldNames.description, renderId: 'description', answer: formData.description }),
        new LongText({ question: fieldNames.address, renderId: 'address', answer: formData.address }),
        new SingleSelection({
          question: fieldNames.kommun,
          renderId: 'kommun',
          options: this.state.dropDownCities.map(c => {
            return {
              value: c.value,
              label: c.value,
              selected: formData?.kommun?.value === c.value
            };
          }),
          required: true,
        }),
        new MultiSelection({
          question: fieldNames.places,
          renderId: 'places',
          options: this.state.places.map(option => {
            return {
              value: option.value,
              label: option.label,
              selected: formData.places.includes(option.value),
            };
          }),
          required: false,
        }),
        new ShortText({ question: fieldNames.website, renderId: 'website', answer: formData.website, }),
        new MultiSelection({
          question: t('addSupplier.label.area', 'Yrkeskategori'),
          renderId: 'areaIds',
          options: this.state.areas.map(option => {
            return {
              value: option.value,
              label: option.label,
              selected: formData.areaIds.includes(option.id),
            };
          }),
          required: true,
        }),
        new LongText({ question: t('addSupplier.files.frameworkAgreement.headline', 'Ramavtal'), renderId: 'frameworkAgreement', answer: '' }),
        new LongText({ question: t('addSupplier.files.liabilityInsurance.headline', 'Ansvarsförsäkring'), renderId: 'liabilityInsurance', answer: '' }),
        new LongText({ question: t('addSupplier.files.other.headline', 'Övriga filer'), renderId: 'otherFiles', answer: '' }),
        new Paragraph({ renderId: 'contactsHeadline', text: `<div><h3 style="padding-bottom: 10px; border-bottom: 1px solid #e5e7eb">${t('addSupplier.contacts.heading', 'Kontaktpersoner')}</h3><p style="margin-bottom: 0;">${t('addSupplier.contacts.supplierApplication.info', 'Eventuella frågor om denna ansökan kommer skickas till den första kontaktpersonen nedan.')}</p></div>`, }),
        ...this.state.contacts.map((person, index) => {
          return new LongText({ question: `${t('addSupplier.contacts.heading', 'Kontaktpersoner')}-${index+1}`, renderId: `contact-${index+1}`, answer: `${t('addSupplier.profileInfo.diff.label.name', 'Namn')}: ${person.name}<br/>${t('addSupplier.profileInfo.diff.label.email', 'Email')}: ${person.email}<br/>${t('addSupplier.profileInfo.diff.label.title', 'Titel')}: ${person.title}<br/>${t('addSupplier.profileInfo.diff.label.phone', 'Telefon')}: ${person.phone}` });
        }),
        new Paragraph({ renderId: 'messageHeadline', text: `<div><h3 style="padding-bottom: 10px; border-bottom: 1px solid #e5e7eb">${t('addSupplier.supplierApplication.message.heading', 'Övriga uppgifter')}</h3><p style="margin-bottom: 0;">${t('addSupplier.supplierApplication.message.intro', 'Kompletterande uppgifter som kan användas vid bedömning av ansökan, men som inte blir en del av företagspresentationen i leverantörsdatabasen.')}</p></div>` }),
        new LongText({ question: t('addSupplier.supplierApplication.message.label', 'Meddelande'), renderId: 'message', answer: formData.message }),
      ];

      const submittableForm = getSubmittableForm(this.state.applicationForm, (form) => {
        this.setState({ applicationForm: form });
      }, Mode.FORM);

      if (submittableForm) {
        const listOfElements = convertedElements.map(element => element.getForDB(Mode.FORM));
        listOfElements.splice(listOfElements.length - 2, 0, ...submittableForm.elements);

        formData.applicationForm = {...submittableForm, elements: listOfElements};
      }
    }

    const invalidContacts = !validateSupMembers(contacts);
    const invalidAds = !validateAds(ads);
    if (Object.keys(formErrors).length || invalidContacts || invalidAds) {
      this.setState({ formErrors: formErrors, btnLoader: false });
      if (this.props.supplierApplication) {
        NotificationManager.error(
          t('addSupplier.notification.error.validation.description', 'Ett eller flera fält saknades eller var ogiltigt, se rödmarkeringar.'),
          t('addSupplier.notification.error.validation.title', 'Ej skickat')
        );
      }
      return;
    }

    if (appState.getCurrentOrgSlug() === 'superadmin' && this.props.supplierApplication) {
      if (!agreedToContract) {
        NotificationManager.error(
          t('addSupplier.notification.error.contractAgreement.description', 'Du måste godkänna användaravtalet'),
          t('addSupplier.notification.error.contractAgreement.title', 'Ej skickat')
        );
        return;
      }
    }

    this.toggleBtnLoader();
    formData.kommun = formData.kommun?.value || formData.kommun;

    // Some field(s) from the form are not valid, error messages appeared on those fields.
    if (!formData.applicationForm && this.state.applicationForm) {
      // Already validated the fields so return
      return;
    }

    try {
      const data = this.state.data;

      const toExistingMeta = (e) => ({
        _id: e._id,
        validUntilDate: e.validUntilDate,
        comment: e.comment,
        fileRemoved: !e.file,
      });
      const withoutReplacement = (arr) => (arr || []).filter((e) => !e.replacementFile);
      const withReplacement = (arr) => (arr || []).filter((e) => e.replacementFile);

      if (supplierId) {
        formData.existingFrameworkAgreements = withoutReplacement(data.existingFrameworkAgreements).map(toExistingMeta);
        formData.existingLiabilityInsurances = withoutReplacement(data.existingLiabilityInsurances).map(toExistingMeta);
        formData.existingUE2021Forms = withoutReplacement(data.existingUE2021Forms).map(toExistingMeta);
      }

      const toNewMeta = ({ file, key, ...rest }) => ({ ...rest, hasFile: !!file });
      const replacementMeta = (e) => ({ validUntilDate: e.validUntilDate, comment: e.comment, hasFile: true });

      formData.newFrameworkAgreements = [...(data.newFrameworkAgreements || []).map(toNewMeta), ...withReplacement(data.existingFrameworkAgreements).map(replacementMeta)];
      formData.newLiabilityInsurances = [...(data.newLiabilityInsurances || []).map(toNewMeta), ...withReplacement(data.existingLiabilityInsurances).map(replacementMeta)];
      formData.newUE2021Forms = [...(data.newUE2021Forms || []).map(toNewMeta), ...withReplacement(data.existingUE2021Forms).map(replacementMeta)];

      const otherFiles = (data.newOtherFiles || []).reduce((prev, curr, index) => {
        if (curr.file) prev[`otherFiles${index}`] = curr.file;
        return prev;
      }, {});

      const collectSectionFiles = (newArr, existingArr, key) => {
        const out = {};
        let i = 0;
        (newArr || []).forEach((curr) => { if (curr.file) out[`${key}${i++}`] = curr.file; });
        (existingArr || []).forEach((e) => { if (e.replacementFile) out[`${key}${i++}`] = e.replacementFile; });
        return out;
      };

      const files = {
        ...otherFiles,
        ...collectSectionFiles(data.newFrameworkAgreements, data.existingFrameworkAgreements, 'frameworkAgreements'),
        ...collectSectionFiles(data.newLiabilityInsurances, data.existingLiabilityInsurances, 'liabilityInsurances'),
        ...collectSectionFiles(data.newUE2021Forms, data.existingUE2021Forms, 'ue2021Forms'),
        ...this.state.files,
      };

      if (supplierId) {
        formData.supplierId = supplierId;
        formData.createdBy = appState.state.token.id;
        const response = await ServiceSupplier.updateSupplier({ ...formData }, files);
        this.handleSuccessResponse(response, t('addSupplier.notification.success.updateSupplier', 'Leverantören uppdaterades'), true);
      } else {
        if (this.props.supplierApplication) {
          const response = await ServiceSupplier.saveSupplierApplication({ ...formData, language: appState.state.language }, files);
          this.handleSuccessResponse(response, t('addSupplier.notification.success.supplierApplication', 'Ansökan skickad'), false);
        } else if ((appState.getCurrentOrg()?.onlyAdminsCanCreateSuppliers && appState.isNonAdminUser())) {
          const response = await ServiceSupplier.saveSupplierApplication({ ...formData, language: appState.state.language, internalApplication: true }, files);
          this.handleSuccessResponse(response, t('addSupplier.notification.success.supplierApplication', 'Ansökan skickad'), false);
        } else {
          formData.createdBy = appState.state.token.id;

          const response = await ServiceSupplier.saveSupplier({ ...formData }, files);
          this.handleSuccessResponse(response, t('addSupplier.notification.success.saveSupplier', 'Leverantören har lagts till'), false);
        }
      }
    } catch (e) {
      if (e?.response?.data?.existingFields) {
        const newFormErrors = {};
        e?.response?.data?.existingFields.forEach(field => {
          newFormErrors[field] = t('addSupplier.validation.fieldAlreadyExists', '{{fieldName}} finns redan', { fieldName: fieldNames[field]});
        })
        this.setState({ formErrors: {...formErrors, ...newFormErrors}, btnLoader: false });
        if (this.props.supplierApplication) {
          NotificationManager.error(
            t('addSupplier.notification.error.validation.description', 'Ett eller flera fält saknades eller var ogiltigt, se rödmarkeringar.'),
            t('addSupplier.notification.error.validation.title', 'Ej skickat')
            );
        }
      } else {
        this.toggleBtnLoader();
        const expectedBackendErrorCodes = ['error.validationError', 'error.notFound', 'error.accessDenied', 'error.contactsNotSaved'];
        NotificationManager.error(
          expectedBackendErrorCodes.includes(e?.response?.data?.error)
            ? t('backend.' + e?.response?.data?.error)
            : t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error: e?.response?.data?.error }),
          t('notification.error.unexpected.title', 'Misslyckat')
        );
      }
    } finally {
      this.setState({ btnLoader: false });
    }
  };

  handleSuccessResponse = (data, msg, isEditMode) => {
    NotificationManager.success(msg);
    this.props.saveSupplier(data, undefined, isEditMode);
    this.props.setShow(false);
  };

  handleChange = (field, value, isFile = false) => {
    let {data, files} = this.state;
    if (isFile) {
      files[field] = value;
    } else {
      data[field] = value;
    }
    this.setState({ data, files, formErrors: {...this.state.formErrors, [field]: ''} });
  };

  handleOrgChange = value => {
    let orgVal = value?.trim();

    if (/^[0-9]{7,10}$/.test(orgVal)) { // add dash if org number is 7-10 digits
      orgVal = orgVal.slice(0, 6) + '-' + orgVal.slice(6);
    }

    if (!/^[0-9]{0,6}-?[0-9]{0,4}$/.test(orgVal)) return; // Reject if not a valid org number prefix

    const complete = checkOrgNo(orgVal);
    this.setState(prev => ({
      data: { ...prev.data, organizationNumber: orgVal },
      formErrors: { ...prev.formErrors, organizationNumber: '' },
      ...(complete ? {} : { supplierProfile: this.emptySupplierProfile(), showQuickCheck: false }),
    }));

    if (complete) this.lookUpCompany(orgVal);
  };

  onIdentityFieldChange = value => {
    const { data } = this.state;
    if (data.selectedIdentityField?.value === 'organizationNumber') {
      this.handleOrgChange(value);
    } else if (data.selectedIdentityField?.value === 'vatNumber') {
      this.handleChange('vatNumber', value)
    }
  }

  onIdentityOptionChange = field => {
    this.setState(prev => ({
      data: { ...prev.data, selectedIdentityField: field },
      showQuickCheck: field.value == 'vatNumber' ? false : prev.showQuickCheck,
    }));
  };

  onCompanyPick = company => {
    if (!company) {
      this.clearCompanyPick();
      return;
    }

    this.setState(prev => {
      const fields = registerFields(company, prev.dropDownCities);
      return {
        data: { ...prev.data, ...fields },
        formErrors: {
          ...prev.formErrors,
          organizationNumber: '',
          name: '',
          kommun: fields.kommun ? '' : prev.formErrors.kommun,
        },
      };
    });

    this.lookUpCompany(company.orgNumber);
  };

  lookUpCompany = async orgNumber => {
    if (this.props.supplierApplication) return;
    this.setState({ lookingUp: orgNumber });
    const [answer, profile] = await Promise.all([
      this.requestCompanyData(orgNumber),
      serviceSales.fetchSupplierProfileForOrgNumber(orgNumber).catch(() => null),
    ]);
    this.setState(prev => ({
      ...mergeCompanyLookUp(prev, { orgNumber, answer, profile }, prev.dropDownCities),
      ...(prev.lookingUp === orgNumber ? { lookingUp: null } : {}),
    }));
  };

  clearCompanyPick = () => {
    this.setState(prev => ({
      data: { ...withoutProfileFields(prev.data, prev.supplierProfile), organizationNumber: '' },
      formErrors: { ...prev.formErrors, organizationNumber: '' },
      supplierProfile: this.emptySupplierProfile(),
      showQuickCheck: false,
    }));
  };

  requestCompanyData = async orgNum => {
    const requestingOrg = appState.getOrgFromUrl();
    const organizationHasSyna = !this.props.supplierApplication && requestingOrg?.hasSyna;
    const organizationHasCreditsafe = !this.props.supplierApplication && requestingOrg?.hasCreditsafe;
    const organizationHasTic = !this.props.supplierApplication && requestingOrg?.hasTic;

    // TODO: Remove this guard clause if/when we want to enable Tic checkup as fallback for everyone
    if (!(organizationHasSyna || organizationHasCreditsafe || organizationHasTic)) return null;

    let response;
    try {
      response = await serviceCredibility.getCompanyData(orgNum, this.state.supplierId);
    } catch (error) {
      NotificationManager.error(this.props.t('notification.error.couldNotGetCompanyData', 'Det gick inte att hämta företagsdata.'));
      response = error.response;
    }

    if (response?.data?.error) {
      return { error: response.data.error };
    } else if (response?.data?.Svar?._attributes.ec.toLowerCase() === 'ok') {
      return { companyData: serviceCredibility.filterSynaCompanyData(response.data.Svar.Objektlista) };
    } else if (response?.status === 200 && response.data?.name) {
      return { companyData: serviceCredibility.filterCreditsafeCompanyData(response.data) };
    } else if (!(organizationHasSyna || organizationHasCreditsafe) && response?.data?.document) {
      return { companyData: serviceCredibility.filterTicCompanyData(response.data.document) };
    }
    return null;
  };

  checkAreaItems = areaIds => {
    const dataIds = areaIds.map(s => s.id);
    const data = this.state.data;
    data.areaIds = dataIds;
    this.setState({ data });
  };

  onAddArea = async newAreaName => {
    const { defaultAreaIds } = this.state;
    const { t, fetchNewAreas } = this.props;

    if (!newAreaName) return;

    this.setState({ loading: true });

    try {
      const updatedAreas = await serviceAreas.addArea({ name: newAreaName });
      if(updatedAreas && fetchNewAreas) fetchNewAreas(updatedAreas);

      NotificationManager.success(t('notification.success.addSupplierArea', 'Yrkeskategori tillagd'));

      const newAddedArea = updatedAreas.find(el => el.name.toLowerCase() === newAreaName.toLowerCase());
      if (newAddedArea) {
        defaultAreaIds.push({
          id: newAddedArea._id,
          value: newAddedArea.name,
          label: formatAreaLabel(newAddedArea.name, newAddedArea.accountNumber),
        });
        this.checkAreaItems(defaultAreaIds);
      }
      this.setState({ defaultAreaIds });
    } catch (error) {
      console.log(error, 'error');
      NotificationManager.error(this.props.t('notification.error.addSupplierArea', 'Något gick fel'));
    } finally {
      this.fetchAreas();
      this.setState({ loading: false });
    }
  };

  onSelect = areaIds => {
    this.setState({ defaultAreaIds: [...areaIds], formErrors: {...this.state.formErrors, areaIds: ''}});
    this.checkAreaItems(areaIds);
  };

  renderUE2021Forms(data) {
    const existingFiles = this.state.data?.existingUE2021Forms || [];
    const newFiles = this.state.data?.newUE2021Forms || [];
    const hasFiles = existingFiles.length > 0 || newFiles.length > 0;
    const isExpanded = this.state.ue2021FormsExpanded;

    return <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {hasFiles && (
        <div
          onClick={() => this.setState({ ue2021FormsExpanded: !isExpanded })}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            userSelect: 'none'
          }}
        >
          <p style={{ margin: 0 }}>{this.props.t('addSupplier.files.ue2021.headline', 'UE2021')}</p>
          {existingFiles.length > 0 && (
            <div className="number-of-files-holder">
              <p className="number-of-files-text">{existingFiles.length}</p>
              <FileIcon className="number-of-files-icon" />
            </div>
          )}
          <ArrowIcon className={`sp-db-arrow-icon ${isExpanded ? 'sp-db-arrow-icon--down' : ''}`} />
        </div>
      )}

      <div className={`framework-agreements-files-container ${isExpanded ? 'expanded' : ''}`}>
        {existingFiles.map((file, index) => (
        <FileUploadRow
          key={file._id || `existing-ue2021-${index}`}
          existingFile={{
            ...file,
            file: file.file?.file,
            fileName: file.file?.fileName
          }}
          setExistingFile={(updated) => {
            const newExisting = [...existingFiles];
            if (updated === null) {
              newExisting.splice(index, 1);
            } else {
              newExisting[index] = {
                ...updated,
                file: updated.file ? { file: updated.file, fileName: updated.fileName } : undefined
              };
            }
            this.setState({ data: { ...data, existingUE2021Forms: newExisting } });
          }}
          label={this.props.t('addSupplier.files.ue2021.selectFile', 'Välj fil')}
          scope={FileScope.SupplierFiles}
          scopeOptions={{ supplierId: this.state.supplierId }}
          hasRemoveButton
          allowMetadataOnly={true}
          isDatePickerFocused={this.state.focusedDatePicker && this.state.focusedDatePicker.sectionKey === 'ue2021' && this.state.focusedDatePicker.index === index && this.state.focusedDatePicker.isNew === false}
          renderFields={(file) => [
            <Field
              key="comment"
              label={this.props.t('addSupplier.files.comment', 'Kommentar')}
              value={file.comment || ''}
              onChange={(value) => {
                const newExisting = [...existingFiles];
                newExisting[index] = { ...newExisting[index], comment: value };
                this.setState({ data: { ...data, existingUE2021Forms: newExisting } });
              }}
            />,
            <DatePicker
              key="submittedDate"
              label={this.props.t('addSupplier.files.submittedDate', 'Inlämnad den')}
              selected={file.submittedDate ? new Date(file.submittedDate) : null}
              onChange={(date) => {
                const newExisting = [...existingFiles];
                newExisting[index] = { ...newExisting[index], submittedDate: date };
                this.setState({ data: { ...data, existingUE2021Forms: newExisting } });
              }}
              onFocus={() => this.setState({ focusedDatePicker: { sectionKey: 'ue2021', index, isNew: false } })}
              onBlur={() => this.setState({ focusedDatePicker: null })}
            />
          ]}
        />
        ))}

        {newFiles.map((file, index) => (
        <FileUploadRow
          key={file.key}
          newFile={file}
          setNewFile={(updated) => {
            const newArr = [...newFiles];
            if (updated === null) {
              newArr.splice(index, 1);
            } else {
              newArr[index] = updated;
            }
            this.setState({ data: { ...data, newUE2021Forms: newArr } });
          }}
          label={this.props.t('addSupplier.files.ue2021.selectFile', 'Välj fil')}
          scope={FileScope.SupplierFiles}
          scopeOptions={{ supplierId: this.state.supplierId }}
          hasRemoveButton
          allowMetadataOnly={true}
          isDatePickerFocused={this.state.focusedDatePicker && this.state.focusedDatePicker.sectionKey === 'ue2021' && this.state.focusedDatePicker.index === index && this.state.focusedDatePicker.isNew === true}
          renderFields={(file) => [
            <Field
              key="comment"
              label={this.props.t('addSupplier.files.comment', 'Kommentar')}
              value={file.comment || ''}
              onChange={(value) => {
                const newArr = [...newFiles];
                newArr[index] = { ...newArr[index], comment: value };
                this.setState({ data: { ...data, newUE2021Forms: newArr } });
              }}
            />,
            <DatePicker
              key="submittedDate"
              label={this.props.t('addSupplier.files.submittedDate', 'Inlämnad den')}
              selected={file.submittedDate ? new Date(file.submittedDate) : null}
              onChange={(date) => {
                const newArr = [...newFiles];
                newArr[index] = { ...newArr[index], submittedDate: date };
                this.setState({ data: { ...data, newUE2021Forms: newArr } });
              }}
              onFocus={() => this.setState({ focusedDatePicker: { sectionKey: 'ue2021', index, isNew: true } })}
              onBlur={() => this.setState({ focusedDatePicker: null })}
            />
          ]}
            hasRemoveText={true}
        />
        ))}
      </div>

      {!hasFiles && (
        <p style={{ margin: 0 }}>{this.props.t('addSupplier.files.ue2021.headline', 'UE2021')}</p>
      )}

      <BtButton
        color="white"
        size="xxs"
        leftIcon={<AddCircleIcon htmlColor="var(--orange-500)" />}
        style={{ width: 'fit-content' }}
        onClick={() => {
          this.setState({
            data: { ...data, newUE2021Forms: [...newFiles, { key: `${Date.now()}` }] },
            ue2021FormsExpanded: true
          });
        }}
      >
        {this.props.t('addSupplier.files.ue2021.headline', 'UE2021')}
      </BtButton>
    </div>
  }

  renderLiabilityInsurances(data) {
    const existingFiles = this.state.data?.existingLiabilityInsurances || [];
    const newFiles = this.state.data?.newLiabilityInsurances || [];
    const hasFiles = existingFiles.length > 0 || newFiles.length > 0;
    const isExpanded = this.state.liabilityInsurancesExpanded;

    return <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {hasFiles && (
        <div
          onClick={() => this.setState({ liabilityInsurancesExpanded: !isExpanded })}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            userSelect: 'none'
          }}
        >
          <p style={{ margin: 0 }}>{this.props.t('addSupplier.files.liabilityInsurance.headline', 'Ansvarsförsäkring')}</p>
          {existingFiles.length > 0 && (
            <div className="number-of-files-holder">
              <p className="number-of-files-text">{existingFiles.length}</p>
              <FileIcon className="number-of-files-icon" />
            </div>
          )}
          <ArrowIcon className={`sp-db-arrow-icon ${isExpanded ? 'sp-db-arrow-icon--down' : ''}`} />
        </div>
      )}

      <div className={`framework-agreements-files-container ${isExpanded ? 'expanded' : ''}`}>
        {existingFiles.map((file, index) => (
        <FileUploadRow
          key={file._id || `existing-liability-${index}`}
          existingFile={{
            ...file,
            file: file.file?.file,
            fileName: file.file?.fileName
          }}
          setExistingFile={(updated) => {
            const newExisting = [...existingFiles];
            if (updated === null) {
              newExisting.splice(index, 1);
            } else {
              newExisting[index] = {
                ...updated,
                file: updated.file ? { file: updated.file, fileName: updated.fileName } : undefined
              };
            }
            this.setState({ data: { ...data, existingLiabilityInsurances: newExisting } });
          }}
          label={this.props.t('addSupplier.files.liabilityInsurance.selectFile', 'Välj fil')}
          scope={FileScope.SupplierFiles}
          scopeOptions={{ supplierId: this.state.supplierId }}
          hasRemoveButton
          allowMetadataOnly={true}
          isDatePickerFocused={this.state.focusedDatePicker && this.state.focusedDatePicker.sectionKey === 'liability' && this.state.focusedDatePicker.index === index && this.state.focusedDatePicker.isNew === false}
          renderFields={(file) => [
            <Field
              key="comment"
              label={this.props.t('addSupplier.files.comment', 'Kommentar')}
              value={file.comment || ''}
              onChange={(value) => {
                const newExisting = [...existingFiles];
                newExisting[index] = { ...newExisting[index], comment: value };
                this.setState({ data: { ...data, existingLiabilityInsurances: newExisting } });
              }}
            />,
            <DatePicker
              key="validUntilDate"
              label={this.props.t('addSupplier.files.validUntil', 'Giltigt till')}
              selected={file.validUntilDate}
              onChange={(date) => {
                const newExisting = [...existingFiles];
                newExisting[index] = { ...newExisting[index], validUntilDate: date };
                this.setState({ data: { ...data, existingLiabilityInsurances: newExisting } });
              }}
              onFocus={() => this.setState({ focusedDatePicker: { sectionKey: 'liability', index, isNew: false } })}
              onBlur={() => this.setState({ focusedDatePicker: null })}
            />
          ]}
            hasRemoveText={true}
        />
        ))}

        {newFiles.map((file, index) => (
        <FileUploadRow
          key={file.key}
          newFile={file}
          setNewFile={(updated) => {
            const newArr = [...newFiles];
            if (updated === null) {
              newArr.splice(index, 1);
            } else {
              newArr[index] = updated;
            }
            this.setState({ data: { ...data, newLiabilityInsurances: newArr } });
          }}
          label={this.props.t('addSupplier.files.liabilityInsurance.selectFile', 'Välj fil')}
          scope={FileScope.SupplierFiles}
          scopeOptions={{ supplierId: this.state.supplierId }}
          hasRemoveButton
          allowMetadataOnly={true}
          isDatePickerFocused={this.state.focusedDatePicker && this.state.focusedDatePicker.sectionKey === 'liability' && this.state.focusedDatePicker.index === index && this.state.focusedDatePicker.isNew === true}
          renderFields={(file) => [
            <Field
              key="comment"
              label={this.props.t('addSupplier.files.comment', 'Kommentar')}
              value={file.comment || ''}
              onChange={(value) => {
                const newArr = [...newFiles];
                newArr[index] = { ...newArr[index], comment: value };
                this.setState({ data: { ...data, newLiabilityInsurances: newArr } });
              }}
            />,
            <DatePicker
              key="validUntilDate"
              label={this.props.t('addSupplier.files.validUntil', 'Giltigt till')}
              selected={file.validUntilDate}
              onChange={(date) => {
                const newArr = [...newFiles];
                newArr[index] = { ...newArr[index], validUntilDate: date };
                this.setState({ data: { ...data, newLiabilityInsurances: newArr } });
              }}
              onFocus={() => this.setState({ focusedDatePicker: { sectionKey: 'liability', index, isNew: true } })}
              onBlur={() => this.setState({ focusedDatePicker: null })}
            />
          ]}
        />
        ))}
      </div>

      {!hasFiles && (
        <p style={{ margin: 0 }}>{this.props.t('addSupplier.files.liabilityInsurance.headline', 'Ansvarsförsäkring')}</p>
      )}

      <BtButton
        color="white"
        size="xxs"
        leftIcon={<AddCircleIcon htmlColor="var(--orange-500)" />}
        style={{ width: 'fit-content' }}
        onClick={() => {
          this.setState({
            data: { ...data, newLiabilityInsurances: [...newFiles, { key: `${Date.now()}` }] },
            liabilityInsurancesExpanded: true
          });
        }}
      >
        {this.props.t('addSupplier.files.liabilityInsurance.headline', 'Ansvarsförsäkring')}
      </BtButton>
    </div>
  }

  renderProfileLiabilityInsurances(liabilityInsurances) {
    const files = liabilityInsurances || [];
    const hasFiles = files.length > 0;

    return <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {hasFiles && <p>{this.props.t('addSupplier.files.liabilityInsurance.headline_supplierProfile', 'Ansvarsförsäkring från leverantörsprofil')}</p>}
      {files.filter(file => file != null).map((file, index) => (
        <SimpleFile
          key={file._id || `profile-liability-${index}`}
          file={file.file?.file}
          fileName={file.file?.fileName}
          comment={file.comment}
          validUntilDate={file.validUntilDate}
          scope={FileScope.SupplierProfileFile}
          scopeOptions={{ organizationNumber: this.state.data.organizationNumber }}
        />
      ))}
    </div>
  }

  renderFrameworkAgreements(data) {
    const existingFiles = this.state.data?.existingFrameworkAgreements || [];
    const newFiles = this.state.data?.newFrameworkAgreements || [];
    const hasFiles = existingFiles.length > 0 || newFiles.length > 0;
    const isExpanded = this.state.frameworkAgreementsExpanded;

    return <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {hasFiles && (
        <div
          onClick={() => this.setState({ frameworkAgreementsExpanded: !isExpanded })}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            userSelect: 'none'
          }}
        >
          <p style={{ margin: 0 }}>{this.props.t('addSupplier.files.frameworkAgreement.headline', 'Ramavtal')}</p>
          {existingFiles.length > 0 && (
            <div className="number-of-files-holder">
              <p className="number-of-files-text">{existingFiles.length}</p>
              <FileIcon className="number-of-files-icon" />
            </div>
          )}
          <ArrowIcon className={`sp-db-arrow-icon ${isExpanded ? 'sp-db-arrow-icon--down' : ''}`} />
        </div>
      )}

      <div className={`framework-agreements-files-container ${isExpanded ? 'expanded' : ''}`}>
        {existingFiles.map((file, index) => (
        <FileUploadRow
          key={file._id || `existing-framework-${index}`}
          existingFile={{
            ...file,
            file: file.file?.file,
            fileName: file.file?.fileName
          }}
          setExistingFile={(updated) => {
            const newExisting = [...existingFiles];
            if (updated === null) {
              newExisting.splice(index, 1);
            } else {
              newExisting[index] = {
                ...updated,
                file: updated.file ? { file: updated.file, fileName: updated.fileName } : undefined
              };
            }
            this.setState({ data: { ...data, existingFrameworkAgreements: newExisting } });
          }}
          label={this.props.t('addSupplier.files.frameworkAgreement.selectFile', 'Välj fil')}
          scope={FileScope.SupplierFiles}
          scopeOptions={{ supplierId: this.state.supplierId }}
          hasRemoveButton
          allowMetadataOnly={true}
          isDatePickerFocused={this.state.focusedDatePicker && this.state.focusedDatePicker.sectionKey === 'framework' && this.state.focusedDatePicker.index === index && this.state.focusedDatePicker.isNew === false}
          renderFields={(file) => [
            <Field
              key="comment"
              label={this.props.t('addSupplier.files.comment', 'Kommentar')}
              value={file.comment || ''}
              onChange={(value) => {
                const newExisting = [...existingFiles];
                newExisting[index] = { ...newExisting[index], comment: value };
                this.setState({ data: { ...data, existingFrameworkAgreements: newExisting } });
              }}
            />,
            <DatePicker
              key="validUntilDate"
              label={this.props.t('addSupplier.files.validUntil', 'Giltigt till')}
              selected={file.validUntilDate}
              onChange={(date) => {
                const newExisting = [...existingFiles];
                newExisting[index] = { ...newExisting[index], validUntilDate: date };
                this.setState({ data: { ...data, existingFrameworkAgreements: newExisting } });
              }}
              onFocus={() => this.setState({ focusedDatePicker: { sectionKey: 'framework', index, isNew: false } })}
              onBlur={() => this.setState({ focusedDatePicker: null })}
            />
          ]}
            hasRemoveText={true}
        />
        ))}

        {newFiles.map((file, index) => (
        <FileUploadRow
          key={file.key}
          newFile={file}
          setNewFile={(updated) => {
            const newArr = [...newFiles];
            if (updated === null) {
              newArr.splice(index, 1);
            } else {
              newArr[index] = updated;
            }
            this.setState({ data: { ...data, newFrameworkAgreements: newArr } });
          }}
          label={this.props.t('addSupplier.files.frameworkAgreement.selectFile', 'Välj fil')}
          scope={FileScope.SupplierFiles}
          scopeOptions={{ supplierId: this.state.supplierId }}
          hasRemoveButton
          allowMetadataOnly={true}
          isDatePickerFocused={this.state.focusedDatePicker && this.state.focusedDatePicker.sectionKey === 'framework' && this.state.focusedDatePicker.index === index && this.state.focusedDatePicker.isNew === true}
          renderFields={(file) => [
            <Field
              key="comment"
              label={this.props.t('addSupplier.files.comment', 'Kommentar')}
              value={file.comment || ''}
              onChange={(value) => {
                const newArr = [...newFiles];
                newArr[index] = { ...newArr[index], comment: value };
                this.setState({ data: { ...data, newFrameworkAgreements: newArr } });
              }}
            />,
            <DatePicker
              key="validUntilDate"
              label={this.props.t('addSupplier.files.validUntil', 'Giltigt till')}
              selected={file.validUntilDate}
              onChange={(date) => {
                const newArr = [...newFiles];
                newArr[index] = { ...newArr[index], validUntilDate: date };
                this.setState({ data: { ...data, newFrameworkAgreements: newArr } });
              }}
              onFocus={() => this.setState({ focusedDatePicker: { sectionKey: 'framework', index, isNew: true } })}
              onBlur={() => this.setState({ focusedDatePicker: null })}
            />
          ]}
        />
        ))}
      </div>

      {!hasFiles && (
        <p style={{ margin: 0 }}>{this.props.t('addSupplier.files.frameworkAgreement.headline', 'Ramavtal')}</p>
      )}

      <BtButton
        color="white"
        size="xxs"
        style={{ width: 'fit-content' }}
        leftIcon={<AddCircleIcon htmlColor="var(--orange-500)" />}
        onClick={() => {
          this.setState({
            data: { ...data, newFrameworkAgreements: [...newFiles, { key: `${Date.now()}` }] },
            frameworkAgreementsExpanded: true
          });
        }}
      >
        {this.props.t('addSupplier.files.frameworkAgreement.headline', 'Ramavtal')}
      </BtButton>
    </div>
  }

  renderOtherFiles(data) {
    const hasOtherFiles = this.state.data?.existingOtherFiles?.length > 0 || this.state.data?.newOtherFiles?.length > 0;

    return <div>
      {hasOtherFiles && <p>{this.props.t('addSupplier.files.other.headline', 'Övriga filer')}</p>}
      <FileUpload
        existingFiles={this.state.data?.existingOtherFiles}
        setExistingFiles={value => this.setState({data: {...data, existingOtherFiles: value}})}
        newFiles={this.state.data?.newOtherFiles}
        setNewFiles={value => this.setState({data: {...data, newOtherFiles: value}})}
        icon={!hasOtherFiles && <AddCircleIcon htmlColor="var(--orange-500)"/>}
        label={this.props.t('addSupplier.files.other.headline', 'Lägg till övriga filer', { context: hasOtherFiles ? 'hasFiles' : undefined })}
        scope={FileScope.SupplierFiles}
        scopeOptions={{ supplierId: this.state.supplierId }}
      />
    </div>
  }

  renderLogo(data) {
    const logoScope = data?.logo?.file?.includes('/supplierProfile/')
      ? FileScope.SupplierProfileLogo
      : FileScope.SupplierLogo;

    const scopeOptions = logoScope === FileScope.SupplierProfileLogo
      ? { organizationNumber: this.state.data.organizationNumber }
      : { supplierId: this.state.supplierId };
    return (
      <LogoForm
        logo={data?.logo}
        scope={logoScope}
        scopeOptions={scopeOptions}
        image={this.state.files.logo}
        readOnly={logoScope === FileScope.SupplierProfileLogo}
        onChange={(file) => {
          if (file) {
            this.setState({ data: {...data, updateLogo: true, logo: file} }, () => {
              this.handleChange('logo', file, true);
            });
          } else {
            this.setState({ data: {...data, logo: {}, updateLogo: true}, files: {...this.state.files, logo: undefined} });
          }
        }}
      />
    )
  }

  renderAdImage(data) {
    const { t } = this.props;
    return (
      <div>
        <p style={{ marginTop: 0, marginBottom: '7px', fontSize: '14px', fontWeight: 500, color: 'var(--gray-700)' }}>{t('addSupplier.ads.label.image', 'Annonsbild')}</p>
        <ImagePreview
          image={data?.featuredInfo?.image}
          fileId={data?.featuredInfo?.image?.file}
          scope={FileScope.FeaturedSupplierImage}
          scopeOptions={{ supplierId: this.state.supplierId }}
          orgSlug={appState.getCurrentOrgSlug()}
          onRemove={() => this.setState({ data: {...data, featuredInfo: {...data?.featuredInfo, image: {}}, updateFeaturedInfoImage: true}, files: {...this.state.files, featuredInfoImage: undefined} })}
          width='250px'
        />
        {!(data?.featuredInfo?.image?.file || data?.featuredInfo?.image?.name) && (
          <label style={{ letterSpacing: 'normal' }}>
            <BtButton
              color="white"
              size="xxs"
              leftIcon={<AddCircleIcon htmlColor="var(--orange-500)"/>}
              style={{ width: 'fit-content' }}
              multiple
            >
              {t('addSupplier.ads.button.addImage', 'Lägg till bild')}
              <input
                type="file"
                name={'featuredInfoImage'}
                accept='image/png, image/gif, image/jpeg'
                onClick={event => { event.target.value = null; }}
                onChange={(e) => {
                  this.setState({ data: {...data, updateFeaturedInfoImage: true, featuredInfo: {...data?.featuredInfo, image: e.target.files[0]}} }, () => {
                    this.handleChange('featuredInfoImage', e.target.files[0], true);
                  });
                }}
                style={{ display: 'none' }}
              />
            </BtButton>
          </label>
        )}
      </div>
    )
  }

  emptySupplierProfile = () => ({
    areas: [],
    places: [],
    contacts: [],
    otherEmailAddresses: [],
  });

  renderFormSlide() {
    const { t } = this.props;
    const {
      areas,
      data,
      lookingUp,
      dropDownCities,
      contacts,
      defaultAreaIds,
      formErrors,
      loading,
      ads,
      showQuickCheck,
    } = this.state;
    const orgNumLoader = lookingUp !== null;

    const { selectedIdentityField } = data;
    const requestingOrg = appState.getOrgFromUrl();
    const organizationHasSyna = !this.props.supplierApplication && requestingOrg?.hasSyna;
    const organizationHasCreditsafe = !this.props.supplierApplication && requestingOrg?.hasCreditsafe;
    const organizationHasTic = !this.props.supplierApplication && requestingOrg?.hasTic;
    const organizationHasCreditibilityService = organizationHasSyna || organizationHasCreditsafe || organizationHasTic;

    const getErrorMessage = (fieldName) => {
      if (formErrors[fieldName]) {
        if (fieldName == 'organizationNumber') {
          const isValidOrgNumber = /^[0-9]{6}-[0-9]{4}$/.test(data.organizationNumber); // not the same as isValidOrganizationNumber
          if (data.organizationNumber && !isValidOrgNumber) {
            return this.props.t('validation:number', 'Ogiltigt nummer');
          }
        }
        return formErrors[fieldName];
      }
      return '';
    }

    const renderSupplierProfileValue = (value) => {
      if (!value) return null;
      return (
        <span style={{ fontSize: '12px', color: 'var(--gray-500)', lineHeight: '16px' }}>
          {t('addSupplier.supplierName.nameFromProfileLabel', 'Leverantören har angett:')} <span style={{color: 'var(--gray-700)', fontWeight: 500, whiteSpace: 'pre-line' }}>
            {value}
          </span>
        </span>
      );
    }

    const supplierProfile = this.state.supplierProfile ?? this.props.editSupplierData.supplierProfile ?? this.emptySupplierProfile();

    const renderProfileInfo = (d) => {
      const otherEmailAddress = supplierProfile.otherEmailAddresses.find(o => o.email == d.email);
      const contact = supplierProfile.contacts.find(c => c.email == d.email);

      if (contact) {
        const diff = [
          contact.name && contact.name != d.name && <div>{t('addSupplier.profileInfo.diff.label.name', 'Namn')}: {contact.name}</div>,
          contact.title && contact.title != d.title && <div>{t('addSupplier.profileInfo.diff.label.title', 'Titel')}: {contact.title}</div>,
          contact.phone && contact.phone != d.phone && <div>{t('addSupplier.profileInfo.diff.label.phone', 'Telefon')}: {contact.phone}</div>,
        ].filter(x=>x);
        return (
          <TooltipContainer renderReferenceComponent={(className, ref) => <VerifiedIcon className={className} ref={ref} style={{ marginRight: '8px' }} />}>
            <div key="tooltip" style={{maxWidth: '512px', fontWeight: 400, fontSize: '14px', color: 'var(--gray-700)' }}>
              {diff.length ? <>
                {t('addSupplier.profileInfo.diff.intro', 'E-postadressen matchar leverantörens egna uppgifter, men följande uppgifter skiljer sig:')}
                {diff}
              </> : t('addSupplier.profileInfo.diff.intro', 'Kontaktpersonen matchar leverantörens egna uppgifter.', { context: 'noDiff' })}
            </div>
          </TooltipContainer>
        );
      }

      const comment = otherEmailAddress?.comment;

      if (otherEmailAddress?.redirectTo) {
        const supplierProfileContact = supplierProfile.contacts.find(c => c._id == otherEmailAddress.redirectTo);
        const email = supplierProfileContact?.email;
        const contact = contacts.find(c => c.email == email);
        const name = contact?.name ?? supplierProfileContact?.name;
        if (name) {
          return (
            <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginRight: '8px' }} />}>
              <div style={{maxWidth: '512px', fontWeight: 400, fontSize: '14px', color: 'var(--gray-700)' }}>
                {
                  comment ? (
                    <Trans t={t} i18nKey="addSupplier.profileInfo.otherEmailAddress.redirectTo_withComment" values={{ name, comment }}>
                      Leverantören rekommenderar: Kontakta <span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{{name}}</span> i stället ({{comment}}).
                    </Trans>
                  ) : (
                    <Trans t={t} i18nKey="addSupplier.profileInfo.otherEmailAddress.redirectTo">
                      Leverantören rekommenderar: Kontakta <span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{{name}}</span> i stället.
                    </Trans>
                  )
                }
              </div>
            </TooltipContainer>
          );
        }
      } else if (comment) {
        return (
          <TooltipContainer renderReferenceComponent={(className, ref) => <InfoIcon className={className} ref={ref} style={{ marginRight: '8px' }} />}>
            <div style={{maxWidth: '512px', fontWeight: 400, fontSize: '14px', color: 'var(--gray-700)' }}>
              <Trans t={t} i18nKey="addSupplier.profileInfo.otherEmailAddress.comment" values={{ comment }}>
                Meddelande från leverantören: <span style={{fontWeight: 500, color: 'var(--gray-900)'}}>{{comment}}</span>
              </Trans>
            </div>
          </TooltipContainer>
        );
      }
      return null;
    };

    const renderRecommendedContacts = () => {
      const recommendedContacts = supplierProfile.contacts.filter(profileContact => !contacts.find(c => c.email == profileContact.email));
      if (!recommendedContacts.length) return null;
      return (
        <>
          <h3 className="inner-sec-title">{t('addSupplier.recommendedContacts.heading', 'Leverantörens föreslagna kontaktpersoner')}</h3>
          <div style={{ display: 'flex', gap: '25px', flexDirection: 'column' }}>
            {recommendedContacts.map(contact => (
              <SuggestedContactContainer
                member={contact}
                key={contact.email}
                onAdd={() => {
                  let newContacts = contacts.filter(x => !(x.name === '' && x.title === '' && x.email === '' && x.phone === ''));

                  newContacts.push({ ...newContact(), name: contact.name, title: contact.title, email: contact.email, phone: contact.phone });

                  this.setState({ contacts: newContacts });
                }}
              />
            ))}
          </div>
        </>
      );
    }


    return (
      <div className="mx-content overflow-s custom-scrollbar" >
        <div className="slide-1" key="slide1" style={{ display: 'flex', flexDirection: 'column', gap: '25px', width: '650px' }}>
          {!this.state.supplierId && appState.getCurrentOrg()?.onlyAdminsCanCreateSuppliers && appState.isNonAdminUser() && (
            <p style={{ fontSize: '14px', color: 'var(--gray-700)' }}>
              {t(
                'addSupplier.supplierApplication.intro',
                'Endast administratörer kan lägga till leverantörer i {{name}}. Detta formulär skapar i stället en leverantörsansökan, som kan godkännas efter granskning av en administratör.',
                { name: appState.getCurrentOrg()?.name }
              )}
            </p>
          )}
          <SupplierIdentity
            identityType={selectedIdentityField}
            identityOptions={this.identityFieldOptions}
            value={data[selectedIdentityField.value] || ''}
            searchable={!this.state.supplierId}
            errorMessage={getErrorMessage(selectedIdentityField.value)}
            lookingUp={orgNumLoader}
            onLookUp={organizationHasCreditibilityService ? this.lookUpCompany : undefined}
            onIdentityTypeChange={this.onIdentityOptionChange}
            onTypedChange={this.onIdentityFieldChange}
            onCompanyChange={this.onCompanyPick}
          />
          <div key="supplierName">
            <Field required label={t('addSupplier.label.companyName', 'Företagsnamn')} errorMessage={getErrorMessage('name')} value={data.name} onChange={(value) => this.handleChange('name', value)} />
            {renderSupplierProfileValue(supplierProfile.name)}
          </div>
          {showQuickCheck && (
            <div key="quickCheck">
              <SupplierControls
                organizationNumber={this.state.data.organizationNumber}
                companyName={this.state.data.name}
                hasSyna={organizationHasSyna}
                hasCreditsafe={organizationHasCreditsafe}
                hasTic={organizationHasTic}
                className="supplierControls-addSupplierModal"
                history={this.props.history}
              />
            </div>
          )}
          <Field multiline label={t('addSupplier.label.description', 'Beskrivning')} value={data.description} onChange={(value) => this.handleChange('description', value)} />

          {this.renderLogo(data)}

          <div key="address">
            <Field multiline label={t('addSupplier.label.address', 'Adress')} errorMessage={getErrorMessage('address')} value={data.address} onChange={(value) => this.handleChange('address', value)} />
            {renderSupplierProfileValue(supplierProfile.address)}
          </div>

          <Selector
            required
            label={t('addSupplier.label.municipality', 'Kommun')}
            placeholder={t('addSupplier.placeholder.municipality', 'Välj')}
            errorMessage={getErrorMessage('kommun')}
            value={data.kommun}
            options={dropDownCities}
            onChange={v => {
              let _data = data || {};
              _data.kommun = v;
              this.setState({ data: _data, formErrors: {...formErrors, kommun: ''} });
            }}
          />

          <div key="places">
            <PlaceSelector
              noTooltip={this.props.supplierApplication}
              places={data.places || []}
              onChange={places => {
                this.setState({
                  data: { ...data, places },
                  formErrors: { ...formErrors, places: '' }
                });
              }}
              readonly={this.state.supplierProfile?.places?.length > 0}
              forceLabel={this.state.supplierProfile?.places?.length > 0}
              errorMessage={getErrorMessage('places')}
            />
          </div>

          <div key="website">
            <Field label={t('addSupplier.label.website', 'Webbplats')} type='url' value={data.website} onChange={(value) => this.handleChange('website', value)} />
            {renderSupplierProfileValue(supplierProfile.website)}
          </div>

          <div key="areas">
            <Selector
              required
              isDisabled={loading}
              isLoading={loading}
              errorMessage={getErrorMessage('areaIds')}
              label={t('addSupplier.label.area', 'Yrkeskategori')}
              placeholder={t('addSupplier.placeholder.area', 'Välj')}
              isMulti
              isCreatable={!this.props.supplierApplication && appState.isAdminRole()}
              options={areas}
              onCreateOption={this.onAddArea}
              onChange={this.onSelect}
              value={defaultAreaIds}
            />
            {renderSupplierProfileValue(supplierProfile.areas.map(a => a.name).join(', '))}
          </div>

          <div key="files">
            <h3 className="inner-sec-title">{t('addSupplier.files.heading', 'Filer')}</h3>
            <div style={{ display: 'flex', gap: '24px', flexDirection: 'column', }}>
              {!this.props.supplierApplication && this.renderFrameworkAgreements(data)}

              {this.renderLiabilityInsurances(data)}

              {this.renderProfileLiabilityInsurances(supplierProfile.liabilityInsurances)}

              {!this.props.supplierApplication && this.renderUE2021Forms(data)}

              {this.renderOtherFiles(data)}
            </div>
          </div>

          <div className="add-supplier-fields add-edit-supplier-fields">
            <h3 className="inner-sec-title">{t('addSupplier.contacts.heading', 'Kontaktpersoner')}</h3>

            {this.props.supplierApplication && <p>{t('addSupplier.contacts.supplierApplication.info', 'Eventuella frågor om denna ansökan kommer skickas till den första kontaktpersonen nedan.')}</p>}

            <div style={{ display: 'flex', gap: '25px', flexDirection: 'column' }}>
              {contacts.map((contact, index) => {
                const profileInfo = renderProfileInfo(contact);
                return (
                  <SupplierMemberContainer
                    errors={contact.errors}
                    key={contact._id || contact.tempId}
                    editMode={contact.editMode}
                    member={contact}
                    profileInfo={profileInfo}
                    onEdit={() => {
                      this.setState(({ contacts }) => {
                        const newContacts = [...contacts];
                        newContacts[index].editMode = true;
                        return {contacts: newContacts};
                      });
                    }}
                    onChange={(values) => {
                      this.setState(({ contacts }) => {
                        const newContacts = [...contacts];
                        Object.entries(values).forEach(([key, value]) => {
                          newContacts[index][key] = value;
                          if (newContacts[index].errors?.[key]) {
                            newContacts[index].errors[key] = '';
                            if ((key === 'name' || key === 'email') && value === '') {
                              newContacts[index].errors[key] = t('validation:required', 'Obligatoriskt');
                            } else if (key === 'email' && validateEmail(value)) {
                              newContacts[index].errors[key] = t('validation:email', 'Ogiltig e-postadress');
                            } else if (key === 'phone' && value && validateOptionalPhone(value)) {
                              newContacts[index].errors[key] = t('validation:email', 'Ogiltigt telefonnummer');
                            }
                          }
                        });
                        return {contacts: newContacts};
                      })
                    }}
                    onRemove={(contact._id || contacts.filter(c => !c.isRemoved).length > 1) && ((value) => {
                      this.setState(({ contacts }) => {
                        let newContacts = [...contacts];
                        const contact = newContacts[index];

                        if (contact._id) {
                          contact.isRemoved = value;
                          if (contacts.filter(c => !c.isRemoved).length == 0) {
                            newContacts.push(newContact());
                          }
                        } else {
                          newContacts = newContacts.filter(_contact => _contact.tempId !== contact.tempId || _contact._id !== contact._id);
                        }
                        return {contacts: newContacts};
                      })
                    })}
                  />
                )
              })}
            </div>
            <div style={{ paddingTop: contacts?.length ? '24px' : 0 }}>
              <BtButton
                color="white"
                size="xxs"
                leftIcon={<AddCircleIcon htmlColor="var(--orange-500)"/>}
                onClick={() => {
                  this.setState({ contacts: [...contacts, newContact()] })
                }}
              >
                {t('addSupplier.contacts.button.add', 'Lägg till kontaktperson')}
              </BtButton>
            </div>
          </div>

          {renderRecommendedContacts()}

          {appState.getCurrentOrgSlug() === 'superadmin' && !this.props.supplierApplication && (
            <div className="add-supplier-fields add-edit-supplier-fields" style={{marginBottom: !data?.isFeatured ? '175px' : 0}}>
              <h3 className="inner-sec-title">{t('addSupplier.ads.heading', 'Annonsplaceringar')}</h3>
              <div style={{ display: 'flex', gap: '25px', flexDirection: 'column' }}>
                {ads?.map((ad, index) => <RecommendedAd deletable index={index} ad={ad} areas={areas} setState={(getUpdatedState) => this.setState(({ ads }) => ({ ads: getUpdatedState(ads) }))} />)}
              </div>
              <div style={{ paddingTop: ads?.length ? '24px' : 0 }}>
                <BtButton
                  color="white"
                  size="xxs"
                  leftIcon={<AddCircleIcon htmlColor="var(--orange-500)"/>}
                  onClick={() => {
                    this.setState(({ ads }) => {
                      return { ads: [
                        ...ads,
                        {
                          errors: {},
                          startDate: moment().toDate(),
                          endDate: moment().add(1, 'month').toDate(),
                          regions: [],
                          areas: []
                        }
                      ]}
                    })
                  }}
                >
                  {t('addSupplier.ads.button.add', 'Lägg till annonsplacering')}
                </BtButton>
              </div>
              <div>
                <CustomToggle
                  checked={data.isFeatured}
                  onChange={() => this.setState({ data: { ...data, isFeatured: !data.isFeatured, featuredInfo: !data.isFeatured ? {
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'month').toDate(),
                  } : {} }})}
                  icons={false}
                  label={t('addSupplier.ads.label.featured', 'Utvald')}
                />
                {data.isFeatured && (
                  <div className="featuredSupplierOptions">
                    <DatePicker
                      label={t('addSupplier.ads.label.startDate', 'Startdatum')}
                      selected={data?.featuredInfo?.startDate}
                      maxDate={moment(data?.featuredInfo?.endDate).toDate()}
                      onChange={(value) => this.setState(({ data }) => {
                        data.featuredInfo.startDate = value;
                        return { data };
                      })}
                    />
                    <DatePicker
                      label={t('addSupplier.ads.label.endDate', 'Slutdatum')}
                      selected={data?.featuredInfo?.endDate}
                      minDate={moment(data?.featuredInfo?.startDate).toDate()}
                      onChange={(value) => this.setState(({ data }) => {
                        data.featuredInfo.endDate = value;
                        return { data };
                      })}
                    />
                    {this.renderAdImage(data)}
                    <Field
                      label={t('addSupplier.ads.label.title', 'Titel')}
                      value={data?.featuredInfo?.title}
                      onChange={(value) => this.setState({ data: {...data, featuredInfo: {...data.featuredInfo, title: value}} })}
                    />
                    <Field
                      label={t('addSupplier.ads.label.description', 'Beskrivning')}
                      multiline
                      value={data?.featuredInfo?.description}
                      onChange={(value) => this.setState({ data: {...data, featuredInfo: {...data.featuredInfo, description: value}} })}
                    />
                    <Field
                      label={t('addSupplier.ads.label.url', 'URL')}
                      value={data?.featuredInfo?.url}
                      onChange={(value) => this.setState({ data: {...data, featuredInfo: {...data.featuredInfo, url: value}} })}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {this.props.supplierApplication && <>
            {appState.getCurrentOrgSlug() === 'superadmin' && <>
              <h3 className="inner-sec-title">{t('addSupplier.supplierApplication.order.heading', 'Beställning')}</h3>
              <Field
                label={t('addSupplier.supplierApplication.order.label.invoiceAddress', 'Fakturaadress (e-post för PDF-faktura)')}
                value={data.invoiceAddress}
                onChange={(value) => this.handleChange('invoiceAddress', value)}
              />
              <Field
                label={t('addSupplier.supplierApplication.order.label.invoiceReference', 'Märkning/referens på faktura')}
                value={data.invoiceReference}
                onChange={(value) => this.handleChange('invoiceReference', value)}
              />
              <Selector
                label={t('addSupplier.supplierApplication.order.label.invoiceInterval', 'Avtalslängd och pris')}
                options={this.invoiceIntervalOptions}
                value={this.invoiceIntervalOptions.find(o => o.value == data.invoiceInterval)}
                onChange={(value) => this.handleChange('invoiceInterval', value.value)}
              />
              <div>
                <p style={{fontWeight: 500}}>{t('addSupplier.supplierApplication.order.userAgreement.heading', 'Användarvillkor och avtal')}</p>
                <p><a href="http://www.accurator.se/sidor/anvandaravtal-leverantorer" target="_blank" rel="noreferrer">http://www.accurator.se/sidor/anvandaravtal-leverantorer</a></p>
                <p>
                  {t('addSupplier.supplierApplication.order.userAgreement.intro', 'Genom godkännande av ovanstående villkor godkänner Leverantören samt förbinder sig att följa Användarvillkoren. Användaren bekräftar också att man har läst och tagit del av integritetspolicyn och samtycker till att Accurator behandlar personuppgifterna i enlighet med Integritetspolicyn. Användarvillkoren, Integritetspolicyn och den information som Accurator, från tid till annan, anger på Webbplatsen utgör det fullständiga avtalet mellan Användaren och Accurator rörande användningen av Webbplatsen och Tjänsten.')}
                </p>
                <label style={{color: 'var(--gray-700)', letterSpacing: 0, fontSize: '14px'}}><StyledCheckbox checked={this.state.agreedToContract} onChange={value => this.setState({agreedToContract:value})} />{t('addSupplier.supplierApplication.order.userAgreement.label', 'Jag godkänner ovanstående användaravtal.')} <span style={{marginLeft: '3px', color: 'var(--orange-500)'}}>*</span></label>
              </div>
            </>}
            {this.state.applicationForm && (
              <Form
                form={this.state.applicationForm}
                onFormChange={(form) => this.setState({applicationForm: form})}
              />
            )}
            <div>
              <h3 className="inner-sec-title">{t('addSupplier.supplierApplication.message.heading', 'Övriga uppgifter')}</h3>
              <p>{t('addSupplier.supplierApplication.message.intro', 'Kompletterande uppgifter som kan användas vid bedömning av ansökan, men som inte blir en del av företagspresentationen i leverantörsdatabasen.')}</p>
              <Field multiline label={t('addSupplier.supplierApplication.message.label', 'Meddelande')} value={data.message} onChange={(value) => this.handleChange('message', value)} />
            </div>
          </>}
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    if (this.props.supplierApplication) {
      return <>
        {this.renderFormSlide()}
        <div style={{marginTop: '16px'}}>
          <BtButton onClick={this.onSaveSupplier} loaderShow={this.state.btnLoader}>{t('addSupplier.button.send', 'Skicka')}</BtButton>
        </div>
      </>;
    } else {
      return (
        <Modal
          title={this.state.supplierId ? t('addSupplier.heading.edit', 'Redigera leverantör') : t('addSupplier.heading.add', 'Lägg till leverantör')}
          show={this.props.show}
          setShow={this.props.setShow}
          buttonInfo={{ label: this.state.supplierId ? t('addSupplier.button.save', 'Spara') : t('addSupplier.button.add', 'Lägg till'), action: this.onSaveSupplier, loaderShow: this.state.btnLoader, disabled: this.state.btnLoader }}
          isScrollable
        >
          {this.renderFormSlide()}
        </Modal>
      );
    }
  }
}

export default withTranslation(['supplierDatabase', 'validation'])(AppAddEditSupplier);
